module.exports = __webpack_public_path__ + "img/badge_tutorial.b97567a4.jpg";